import { Injectable } from '@angular/core';
import { UtilsService } from './utils.service';
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
  HttpParams,
} from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable()
export class ProvidersCashinService {
  basePath = environment.providersApiBaseUrl;

  constructor(
    private http: HttpClient,
    private utils: UtilsService,
  ) {}

  kushkiCashin(body: any) {
    let url = 'kushki/pe/charges';

    return this.http.post<any>(`${this.basePath}/${url}`, body);
  }
}
